module.exports = __webpack_public_path__ + "static/media/AppointmentIcon.006d4d1e.svg";